var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "11klveh5aa",
    d: "M0 0.021L5.775 0.021 5.775 4.911 0 4.911z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i7i92umm1c",
    d: "M0.081 0.252L0.411 0.252 0.411 0.387 0.081 0.387z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "slkmx4iqze",
    d: "M0.083 0.111L0.343 0.111 0.343 0.25 0.083 0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3jlfgj8ajg",
    d: "M0.188 0.111L0.438 0.111 0.438 0.25 0.188 0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "zqkd1jma1i",
    d: "M0.168 0.252L0.418 0.252 0.418 0.39 0.168 0.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f70l13jg1k",
    d: "M0.071 0.252L0.321 0.252 0.321 0.39 0.071 0.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8ghg72o52m",
    d: "M0.208 0.114L0.458 0.114 0.458 0.25 0.208 0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9oluk9qdko",
    d: "M0.15 0.114L0.4 0.114 0.4 0.25 0.15 0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6qtavh6lcq",
    d: "M0.209 0.114L0.459 0.114 0.459 0.25 0.209 0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jh5j4w165s",
    d: "M0.097 0.114L0.347 0.114 0.347 0.25 0.097 0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aphyol5dru",
    d: "M0.072 0.113L0.322 0.113 0.322 0.25 0.072 0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "8g3ir909lw",
    d: "M0.054 0.114L0.304 0.114 0.304 0.25 0.054 0.25z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-148 -28) translate(148 28)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5,
    height: 21.5,
    x: 0.25,
    y: 0.25,
    fill: "#FFF",
    stroke: "#C7C7C7",
    strokeWidth: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0057A5",
    d: "M19.553.327c.404.024.805.075 1.199.174.212.053.422.118.627.195.038.015.05.03.043.073-.053.312-.102.623-.153.935l-.148.911c-.005.028-.005.057-.022.083-.038-.004-.069-.025-.102-.04-.35-.162-.712-.285-1.093-.346-.433-.07-.868-.086-1.302-.008-.186.033-.363.095-.522.2-.104.068-.194.151-.257.26-.123.21-.115.417.028.616.067.095.153.171.244.241.192.146.402.263.615.374.234.122.47.238.703.362.37.199.715.433 1.01.735.302.308.518.666.612 1.092.052.24.062.485.042.732-.026.314-.093.618-.216.909-.224.53-.588.945-1.062 1.266-.426.29-.898.474-1.397.594-.297.072-.6.111-.904.143-.02.012-.042.004-.063.007H17.293c-.046.004-.094-.01-.14.008h-.376c-.05-.018-.103-.004-.154-.008h-.13c-.026-.003-.052.006-.077-.006-.424-.038-.846-.093-1.261-.19-.27-.063-.535-.138-.792-.243-.017-.007-.033-.016-.05-.021-.033-.011-.042-.028-.035-.065.028-.159.052-.319.078-.479l.179-1.112.07-.43.09.04c.359.17.722.327 1.106.435.308.087.622.133.941.15.209.01.418.02.627.001.238-.022.469-.071.687-.173.136-.064.258-.147.358-.26.227-.26.237-.614.026-.885-.081-.103-.18-.188-.287-.265-.24-.174-.501-.31-.766-.44-.378-.186-.747-.387-1.083-.643-.274-.208-.519-.446-.708-.736-.243-.372-.351-.78-.331-1.225.042-.922.468-1.63 1.203-2.164.43-.313.914-.51 1.428-.638.374-.094.754-.139 1.138-.16.038-.012.076-.002.114-.005h.29c.038.003.077-.007.115.006",
    transform: "translate(3 6)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(0 .468)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "08q6i4ma2b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#11klveh5aa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F8A11B",
    d: "M2.525 1.23c-.196-.123-.403-.229-.612-.33C1.311.608.685.383.037.218.025.215.012.209 0 .205V.19C.028.16.028.123.036.088.051.022.051.022.116.021H3.83c.135 0 .27.014.404.042.405.087.653.335.736.739.104.497.199.996.297 1.495l.275 1.396.226 1.143.006.054c.003.016-.005.021-.02.021-.063-.078-.087-.176-.127-.266-.252-.569-.575-1.094-.965-1.578-.176-.218-.36-.428-.56-.621-.443-.428-.925-.806-1.453-1.124-.044-.026-.094-.045-.124-.092",
    mask: "url(#08q6i4ma2b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(19.063 .155)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lw12wnu1rd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i7i92umm1c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A7B7DC",
    d: "M.406.273H.087C.082.268.08.263.082.258L.087.252h.318c.006.005.007.01.006.015L.406.273",
    mask: "url(#lw12wnu1rd)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(16.563 9.687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fgqtnojv1f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#slkmx4iqze"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#356FB3",
    d: "M.09.228C.173.232.261.201.342.25h-.25C.084.246.081.241.082.236.086.231.088.228.09.228",
    mask: "url(#fgqtnojv1f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(17.031 9.687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sxy0l28nhh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3jlfgj8ajg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#376FB3",
    d: "M.195.25C.268.205.347.23.423.228.43.234.432.238.43.243.426.248.423.25.42.25H.195z",
    mask: "url(#sxy0l28nhh)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(18.906 .155)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ngsrdshpvj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zqkd1jma1i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B6D1E8",
    d: "M.381.252v.021C.322.278.264.283.205.275V.252h.176z",
    mask: "url(#ngsrdshpvj)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(19.375 .155)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "stkb1hzr5l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f70l13jg1k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BED7EB",
    d: "M.108.273V.25h.175l.001.024C.225.283.167.278.108.273",
    mask: "url(#stkb1hzr5l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(16.25 9.687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i0hf71elon",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8ghg72o52m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CCDCED",
    d: "M.265.227L.39.23C.4.233.402.238.4.243.397.248.394.25.392.25H.266V.227",
    mask: "url(#i0hf71elon)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(16.406 9.687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tb1y0o1mfp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9oluk9qdko"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5E95C9",
    d: "M.34.228L.341.25H.217C.209.245.206.24.208.235.211.23.213.228.215.228H.34",
    mask: "url(#tb1y0o1mfp)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(17.188 9.687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l9o2vqqmhr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6qtavh6lcq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A3BADD",
    d: "M.274.229h.124c.007.004.01.01.007.014C.402.248.399.25.397.25H.27C.263.244.261.24.264.235.267.23.27.229.274.229",
    mask: "url(#l9o2vqqmhr)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(17.188 9.687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ei02tv16ft",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jh5j4w165s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5992C7",
    d: "M.274.229L.27.249h-.1L.173.229h.1",
    mask: "url(#ei02tv16ft)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(17.344 9.687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "az7rz6vgbv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aphyol5dru"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E2F0",
    d: "M.147.25V.228l.1-.001V.25h-.1z",
    mask: "url(#az7rz6vgbv)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6) translate(16.406 9.687)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lvfcsavqtx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8g3ir909lw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A1B8DB",
    d: "M.215.228C.217.235.217.243.217.25H.142c0-.007 0-.014-.002-.02L.215.227",
    mask: "url(#lvfcsavqtx)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0057A5",
    d: "M2.525 1.698c.209.113.406.245.6.382.65.458 1.223 1 1.702 1.636.37.492.674 1.022.903 1.594l.028.065c.027.013.012.045.028.064.014.012.001.034.015.047l.156.77.097.482c.004.01.009.011.016.003l.01-.019 1.068-2.867L8.372.562C8.399.49 8.399.49 8.469.49h2.437c.014.035-.008.059-.018.084l-.876 2.152-2.804 6.885c-.007.017-.016.033-.021.05-.01.03-.028.042-.059.04-.015-.002-.031 0-.047 0H4.722c-.09-.002-.072.007-.094-.071-.06-.216-.116-.433-.173-.65L3.63 5.872 2.535 1.744l-.01-.046M14.268.5l-.034.23-.33 2.03-.338 2.078c-.091.567-.181 1.134-.273 1.7l-.323 1.985-.179 1.112c-.011.073-.012.074-.088.074h-2.258c-.05-.003-.054-.005-.045-.055l.19-1.174.166-1.02.18-1.112.181-1.12.197-1.212c.06-.368.12-.737.178-1.105l.18-1.112.182-1.12.026-.154c.004-.026.016-.037.042-.035H14.179c.028 0 .057-.007.09.01",
    transform: "translate(3 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9C5A",
    d: "M5.786 5.439c-.02-.017-.022-.041-.028-.064l.016-.017c.017.025.016.053.012.081",
    transform: "translate(3 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B09981",
    d: "M5.801 5.486c-.014-.013-.021-.028-.016-.048.023.01.016.03.016.048",
    transform: "translate(3 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9CBBDD",
    d: "M6.07 6.741c.001.008-.001.018-.008.017-.013 0-.01-.011-.008-.02l.016.003",
    transform: "translate(3 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9CBBDD",
    d: "M6.08 6.722c.003.01 0 .016-.01.019-.002-.01.003-.015.01-.019",
    transform: "translate(3 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0057A5",
    d: "M20.914 9.7l.18-.432 2.385-5.687.965-2.302c.052-.123.111-.242.192-.349.181-.24.429-.367.721-.414.127-.02.255-.026.383-.026h1.739c.07 0 .07 0 .083.064l.096.46.461 2.213.496 2.374.48 2.29.36 1.73.004.016c.01.068.007.072-.06.072h-2.07c-.065 0-.066-.001-.08-.068-.083-.408-.166-.817-.252-1.226-.022-.102.003-.09-.106-.09H23.99c-.074 0-.074 0-.099.068l-.136.375-.317.875c-.023.065-.023.066-.094.066h-2.359c-.02 0-.042.002-.071-.01",
    transform: "translate(3 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M26.584 6.44h-1.98c.42-1.147.852-2.283 1.256-3.43h.016l.708 3.43",
    transform: "translate(3 6)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentVisa);
export default __webpack_public_path__ + "static/media/payment-visa.7721555e535e9139d79c54dfa9845cda.svg";
export { ForwardRef as ReactComponent };